import React from 'react';
import { TrendingUp } from 'lucide-react';
import { Heading } from '../layout';
import UpsellingTable3 from './UpsellingTable3';

const PaintUpsellingWorkspace = ({ isDarkMode = false }) => {
  return (
    <div>
      <Heading level={2} isDarkMode={isDarkMode}>
        <TrendingUp size={22} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        Upselling
      </Heading>
      <UpsellingTable3 isDarkMode={isDarkMode} />
    </div>
  );
};

export default PaintUpsellingWorkspace;
